import React, { useState, useEffect } from "react";
import "./Customers.css";
// import {Link} from "react-router-dom";
// import Customers_data from "./Customers_data";

const Customer = () => {

    const [data, setdata] = useState([{
        sno: "",
        customer_id: "",
        customer_name: "",
        email: "",
        phone: "",
        balance: ""
    }])

    useEffect(() => {
        fetch("https://basic-bank-app.herokuapp.com/details").then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(jsonres => setdata(jsonres));
    })

    return (
        <>
            <div className="customer_container">

                <div className="table">
                    <table >
                        <thead>
                            <tr className="td">
                                <th>Sno.</th>
                                <th>Account No.</th>
                                <th>Name</th>
                                <th>email</th>
                                <th>Contact</th>
                                <th>Balance</th>

                            </tr>
                        </thead>
                        <tbody>
                            {data.map((obj,index) => {
                                return (
                                    <>
                                        <tr key={index}>
                                            <td data-title="Sno.">{obj.sno}</td>
                                            <td>{obj.customer_id}</td>
                                            <td>{obj.customer_name}</td>
                                            <td>{obj.email}</td>
                                            <td>{obj.phone}</td>
                                            <td>{obj.balance}</td>
                                        </tr>
                                    </>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

            </div>
        </>
    )
}

export default Customer;